import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { DataProvider } from "./Services/DataContext";
import router from "./Routes/App";
import "./index.css"
import { ToastContainer } from "react-toastify";


ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <DataProvider>
    <ToastContainer position="top-right" autoClose={3000} />
      <RouterProvider router={router} />
    </DataProvider>
  </React.StrictMode>
);

